// extracted by mini-css-extract-plugin
module.exports = {"container":"RightNavbar-module--container--2iFOQ"};